'use client';
import { GoArrowLeft } from 'react-icons/go';

const options = [
  { value: 'planning', label: 'Planning for the future' },
  { value: 'launching', label: 'Launching Soon' },
  { value: 'making_money', label: 'Already Making Money' },
];

export default function ProgressStep({ formik, onBack }) {
  return (
    <>
      <button
        type="button"
        onClick={onBack}
        className="mb-[0.5rem] flex cursor-pointer items-center gap-[0.5rem] text-[1rem] font-bold text-dark transition-colors hover:text-blue-600 focus:outline-none"
      >
        <GoArrowLeft size={18} />
        <span className="text-base font-semibold">Back</span>
      </button>
      <h2 className="mb-[1.5rem] text-[1.65rem] font-[500] leading-tight text-black">
        How Far Along Is Your Business?
      </h2>
      <div className="mb-[1rem] flex flex-col gap-[1rem]">
        {options.map((opt) => (
          <label
            key={opt.value}
            className={`flex w-full cursor-pointer items-center rounded-lg border bg-[#F9FAFB] px-[1rem] py-[0.75rem] text-[1rem] font-medium transition-all ${formik.values.progress === opt.value ? 'border-therablue' : 'border-[#E5E7EB]'} ${formik.touched.progress && formik.errors.progress && !formik.values.progress ? 'border-red-500' : ''} `}
          >
            <input
              type="radio"
              name="progress"
              value={opt.value}
              checked={formik.values.progress === opt.value}
              onChange={formik.handleChange}
              className="form-radio mr-[0.75rem] h-[1.25rem] w-[1.25rem] accent-blue-500"
            />
            <span className="text-black">{opt.label}</span>
          </label>
        ))}
        {formik.touched.progress && formik.errors.progress && (
          <div className="mt-[0.25rem] text-[0.875rem] text-red-500">{formik.errors.progress}</div>
        )}
      </div>
    </>
  );
}
